<hpf-module-qcm-response-form
	[moduleQCMResponse]="moduleQCMResponse"
	[loading]="moduleQCMResponse.isNew()"
	(update)="onUpdate()"
	(delete)="onDelete()"
></hpf-module-qcm-response-form>
<div class="container"></div>
